__turbopack_context__.v({
  "bankIcon": "Description-module-scss-module__PkakRq__bankIcon",
  "description": "Description-module-scss-module__PkakRq__description",
  "panId": "Description-module-scss-module__PkakRq__panId",
});
